import React from "react";
import { useLocation } from "react-router";
import FullHeight from "./FullHeight";
import { Link } from "react-router-dom";
import AuthHeader from "../../components/order/AuthHeader";
import { useFormDetailsState } from "../../context/FormDetailsContext";
import { SIGN_UP_PATH_LIST, WELCOME_PATH_LIST } from "../../helpers/constants";

const AuthPage = ({ children }) => {
  const {
    footerHeight: { signup_form },
  } = useFormDetailsState();
  const location = useLocation();
  const { pathname } = location;
  const showSignup = ![...SIGN_UP_PATH_LIST, ...WELCOME_PATH_LIST].includes(
    pathname
  );
  return (
    <FullHeight
      className="home-route"
      footerHeight={SIGN_UP_PATH_LIST.includes(pathname) && signup_form}
      id={pathname}
    >
      <AuthHeader />
      <div
        className="d-flex flex-column flex-grow-1 justify-content-center mx-auto"
        style={{ maxWidth: "450px", width: "100%" }}
      >
        {children}
      </div>
      {showSignup && (
        <p className="text-center mt-auto">
          Don't have an account?{" "}
          <Link className="text-link" to="/signup">
            Sign Up
          </Link>
        </p>
      )}
    </FullHeight>
  );
};

export default AuthPage;
